(() => {
  if (window.ReproVideoPopupReady) return;
  window.ReproVideoPopupReady = true;

  const closeModal = (modal) => {
    if (!modal) return;
    modal.querySelector("iframe")?.removeAttribute("src");
    const video = modal.querySelector("video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    if (modal.open) modal.close();
  };

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-rp-video-open]");
    if (opener) {
      const modal = document.getElementById(opener.dataset.rpVideoOpen);
      if (!modal) return;
      const iframe = modal.querySelector("iframe");
      if (iframe && !iframe.hasAttribute("src"))
        iframe.src = iframe.dataset.rpVideoSrc;
      modal.showModal();
      modal
        .querySelector("video")
        ?.play()
        .catch(() => {});
      return;
    }

    const closeButton = event.target.closest("[data-rp-video-close]");
    if (closeButton) {
      closeModal(closeButton.closest("[data-rp-video-modal]"));
      return;
    }

    const modal = event.target.closest("[data-rp-video-modal]");
    if (modal && event.target === modal) closeModal(modal);
  });

  document.addEventListener(
    "close",
    (event) => {
      if (event.target.matches?.("[data-rp-video-modal]"))
        closeModal(event.target);
    },
    true,
  );

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    document
      .querySelectorAll("[data-rp-video-modal][open]")
      .forEach(closeModal);
  });
})();
